import { collection, doc, getDocs, setDoc, deleteDoc, addDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';

export interface EvaluationScaleOption {
    value: number;
    label: string;
    description?: string;

    // Context-specific fields
    labelLeader?: string;
    descriptionLeader?: string;
    labelCollaborator?: string;
    descriptionCollaborator?: string;
}

export interface EvaluationScale {
    id?: string;
    name: string;
    description: string;
    options: EvaluationScaleOption[];
}

const COLLECTION_NAME = 'evaluation_scales';

export const getEvaluationScales = async (): Promise<EvaluationScale[]> => {
    try {
        const snapshot = await getDocs(collection(db, COLLECTION_NAME));
        return snapshot.docs.map(doc => {
            const data = doc.data();
            if (data.options && data.options.length === 5 && !data.options.some((o: any) => o.value === 0)) {
                data.options.unshift({
                    value: 0,
                    label: 'N/A',
                    description: '',
                    labelLeader: 'N/A',
                    descriptionLeader: '',
                    labelCollaborator: '',
                    descriptionCollaborator: ''
                });
            }
            return {
                id: doc.id,
                ...data
            } as EvaluationScale;
        });
    } catch (error) {
        console.error("Error getting evaluation scales:", error);
        throw error;
    }
};

export const saveEvaluationScale = async (scale: EvaluationScale): Promise<void> => {
    try {
        if (scale.options.length !== 6) {
            throw new Error("Uma escala deve ter exatamente 6 opções.");
        }

        if (scale.id) {
            const docRef = doc(db, COLLECTION_NAME, scale.id);
            await setDoc(docRef, scale);
        } else {
            await addDoc(collection(db, COLLECTION_NAME), scale);
        }
    } catch (error) {
        console.error("Error saving evaluation scale:", error);
        throw error;
    }
};

export const deleteEvaluationScale = async (id: string): Promise<void> => {
    try {
        await deleteDoc(doc(db, COLLECTION_NAME, id));
    } catch (error) {
        console.error("Error deleting evaluation scale:", error);
        throw error;
    }
};
